import { render, staticRenderFns } from "./OtherPage.vue?vue&type=template&id=74a8281c&"
import script from "./OtherPage.vue?vue&type=script&lang=js&"
export * from "./OtherPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports